import {
  isExist,
} from '@qx/utils/index';

// 计算单价
export const getCostPrice = ({
  priceEnum,
  priceUnit,
  weight,
  square,
  cmMileage,
}) => {

  let num = 0;
  if (priceEnum === 1) {
    // 按车计算
    num = 1;
  } else if (priceEnum === 2) {
    // 按千克计算（获取当前输入的重量）
    num = weight * 1000;
  } else if (priceEnum === 3) {
    // 按方计算（获取当前输入的体积）
    num = square;
  } else if (priceEnum === 4) {
    // 按公里计算（获取当前输入的客户公里数）
    num = cmMileage;
  }

  const costPrice = (priceUnit * num).toFixed(2);
  return costPrice;
};

export const getPrePayCashAndAfterPayCash = ({
  costPrice,
  prePayCash,
  afterPayCash,
  balanceType,
  changeType,
}) => {
  let newCostPrice = costPrice;
  let newPrePayCash = prePayCash;
  let newAfterPayCash = afterPayCash;
  if (!isExist(newCostPrice) || isNaN(newCostPrice)) {
    newCostPrice = 0;
  }
  if (!isExist(newPrePayCash) || isNaN(newPrePayCash) || changeType === 1) {
    // 预付全款
    if (Number(balanceType) === 1) {
      newPrePayCash = newCostPrice;
    } else {
      newPrePayCash = 0;
    }
    newAfterPayCash = Number(newCostPrice) - Number(newPrePayCash);
  }

  if (!isExist(newAfterPayCash) || isNaN(newAfterPayCash) || changeType === 1) {
    if (Number(balanceType) !== 1) {
      newAfterPayCash = newCostPrice;
    } else {
      newAfterPayCash = 0;
    }
  }
  return {
    costPrice: Number(newCostPrice),
    prePayCash: Number(newPrePayCash),
    afterPayCash: Number(newAfterPayCash),
  };
};
